import { useQuery } from '@tanstack/react-query';

import { oneMinute } from '../components/common/timeUtils';
import { getStoreIdAssociations, getStoreIdAssociationsKey } from '../components/RMS/rms.services';

type Props = {
  salesChannelId: string;
  enabled: boolean;
};

const useQueryStoreIdAssociations = ({ salesChannelId, enabled = false }: Props) => {
  const {
    data: storeAssociation,
    isLoading: loadingStoreAssociation,
    isError: loadingStoreAssociationError,
  } = useQuery({
    queryKey: [getStoreIdAssociationsKey, salesChannelId],
    // API returns 200 but with null data for marketplace channels without store associations
    queryFn: () => getStoreIdAssociations(salesChannelId ?? ''),
    staleTime: oneMinute * 60,
    enabled,
  });

  return {
    storeId: storeAssociation?.data?.flipdish?.storeId,
    loadingStoreAssociation,
    loadingStoreAssociationError,
  };
};

export default useQueryStoreIdAssociations;
